import React from "react";
import "./Option.scss";

interface IProps {
  id: number;
  type: OptionType;
  isDisabled: boolean;
  callback: (id: number) => void;
}

export enum OptionType {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
}

const Option = (props: IProps) => {

  function handleClick(): void {
    if (props.isDisabled) {
      return;
    }
    props.callback(props.id);
  }

  return (
    <div
      id="option"
      className={props.isDisabled ? 'disabled' : ''}
      onClick={handleClick}
    >
      <span className="type">{props.type}</span>
    </div>
  );
}

export default Option;
